"use client";
import { useEffect, useState } from "react";
import { Flex, Button } from "antd";
import { IconArrowNarrowLeft, IconArrowNarrowRight } from "@/lib/icons";
import styles from "./SliderNavButtons.module.css";

function SliderNavButtons({ prevRef, nextRef, swiper, itemsCount }) {
  const [needsNav, setNeedsNav] = useState(true);

  useEffect(() => {
    if (!swiper || !itemsCount) return undefined;

    const syncNeedsNav = () => {
      const rawSlidesPerView = swiper.params?.slidesPerView;
      const visibleSlides =
        typeof rawSlidesPerView === "number"
          ? rawSlidesPerView
          : Number.parseFloat(rawSlidesPerView) || 1;
      setNeedsNav(itemsCount > Math.floor(visibleSlides + 0.001));
    };
    syncNeedsNav();

    swiper.on("breakpoint resize update", syncNeedsNav);
    return () => {
      swiper.off("breakpoint resize update", syncNeedsNav);
    };
  }, [swiper, itemsCount]);

  const disabled = !swiper || !needsNav;

  return (
    <div className={styles.navBtnWrapper}>
      <Button
        ref={prevRef}
        shape="circle"
        icon={<IconArrowNarrowLeft color="currentColor" size={20} />}
        className={styles.navBtn}
        variant="filled"
        color="default"
        disabled={disabled}
        aria-label="Previous slide"
      />
      <Button
        ref={nextRef}
        shape="circle"
        icon={<IconArrowNarrowRight color="currentColor" size={20} />}
        className={styles.navBtn}
        variant="filled"
        color="default"
        disabled={disabled}
        aria-label="Next slide"
      />
    </div>
  );
}

export default SliderNavButtons;
